module.exports = __webpack_public_path__ + "static/media/5.b1f40b60.png";